import { ReactNode } from 'react';

export function Extras({ children }: { children: ReactNode }) {
  return <dl className="flex flex-col gap-4 py-4">{children}</dl>;
}
